import { useEffect } from "react";

/**
 * Applies a custom CSS cursor (classic arrow shape with green nature fill)
 * globally via a data-URL SVG cursor. No JS-driven div following the mouse.
 */
export default function NaturalCursor() {
  useEffect(() => {
    // Classic arrow cursor with green gradient fill
    const defaultCursor = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='28' viewBox='0 0 24 28'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%235C8068'/%3E%3Cstop offset='50%25' stop-color='%234A6B58'/%3E%3Cstop offset='100%25' stop-color='%233D5A48'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath d='M2 1L2 21L7.5 15.5L12 25L15 23.5L10.5 14L18 14Z' fill='url(%23g)' stroke='%232E2518' stroke-width='1.2' stroke-linejoin='round'/%3E%3C/svg%3E") 2 1, auto`;

    const pointerCursor = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='28' viewBox='0 0 22 28'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%236B9B78'/%3E%3Cstop offset='50%25' stop-color='%235C8068'/%3E%3Cstop offset='100%25' stop-color='%234A7058'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath d='M7 1C7 1 7 9.5 7 12C5 12 3 12 3 12C3 12 3 14 5 14L7 14C7 14 7 15 7 16C5 16 4 16 4 16C4 18 6 18 6 18L7 18C7 19 7 20 7 20C6 20 5 20 5 20C5 22 7 22 7 22L8 22C8.5 24 10 26 12 27C15 27 16 25 16 22L16 14C17 14 18 13 18 12C18 11 17 10 16 10L16 8C16 6 14 5 12 5L12 3C12 2 11 1 10 1C9 1 8 1 7 1Z' fill='url(%23g)' stroke='%232E2518' stroke-width='1' stroke-linejoin='round'/%3E%3C/svg%3E") 7 1, pointer`;

    const style = document.createElement("style");
    style.id = "natural-cursor-styles";
    style.textContent = `
      * { cursor: ${defaultCursor} !important; }
      a, button, [role="button"], select, summary, label, 
      [tabindex]:not([tabindex="-1"]),
      input[type="submit"], input[type="button"], input[type="reset"],
      .cursor-pointer { cursor: ${pointerCursor} !important; }
      input, textarea, [contenteditable="true"] { cursor: text !important; }
    `;
    document.head.appendChild(style);

    return () => {
      style.remove();
    };
  }, []);

  return null;
}